'use client';
import './style.sass';
import {
    changeStrategy,
    difficulties,
    firstStart,
    firstStart2,
    listTarget,
    listTask,
    paragraph,
    paragraph2,
    screenShotCase,
    screenShotCase2,
    statistics,
    statistics1,
    test,
    results,
    statistics2,
    diagrammBlock,
    listTeam,
    nextProjectAvenu,
    listPath,
    listTitle,
    descriptionBlock,
    processBlock,
    strategyText,
    nextStageText,
    optimizationText,
    screenShotCase4,
} from './constants';

import FullWrapper from '../reusable-components/layouts-components__common-cases/full-wrapper';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import TestCaseBlock from '../reusable-components/layouts-component__avenu/test-case';
import TitleCase from '../../case-components/title-case';
import TargetCase from '../../case-components/target-case';
import CaseBlock from '../../case-components/case-block';
import BannerFillWidth from '../../case-components/banner-full-width';
import Task from '../../case-components/tasks-case';
import ScreenshotsCase from '../../case-components/screenshots-case';
import BlocksWithIcons from '../../case-components/case-blocks-with-icons';
import ScrollAnimation from '../../../../../core/ScrollAnimation';
import OfferButton from '../../../../../shared/sections/OfferButton';
import TeamCase from '../../case-components/team-case';
import DiagrammCase from '../../case-components/diagramm-case';

function Avenue() {
    return (
        <section className="avenu">
            <TitleCase
                img="/images/pic/avenu/banner.jpg"
                listPath={listPath}
                listTitle={listTitle}
                caseName="avenu__first-screen"
            />
            <TargetCase listTarget={listTarget} />
            <CaseBlock params={descriptionBlock} className={'avenu__desc'} />
            <BannerFillWidth
                banner="/images/pic/avenu/bannerFullWidth.jpg"
                alt={'Авеню'}
                customClass={'avenu__banner'}
            />
            <Task listTask={listTask} />
            <CaseBlock params={difficulties} className={'avenu__difficult'} />
            <CaseBlock params={processBlock} />
            <FullWrapper isMargin={false}>
                <div className="avenu__subtitle">Тестирование гипотез</div>
            </FullWrapper>
            <CaseBlock params={test}>
                <TestCaseBlock />
            </CaseBlock>
            <FullWrapper isMargin={false}>
                <span className="avenu__flag">первый запуск</span>
            </FullWrapper>
            <CaseBlock params={firstStart} />
            <CaseBlock params={firstStart2} />
            <ScreenshotsCase params={screenShotCase} />
            <CaseBlock params={paragraph} />
            <BlocksWithIcons params={statistics1} />
            <FullWrapper isMargin={false}>
                <div className="avenu__subtitle">Смена стратегии</div>
            </FullWrapper>
            <CaseBlock params={changeStrategy} />
            <ScreenshotsCase params={screenShotCase2} />
            <CaseBlock params={strategyText} />
            <BlocksWithIcons params={statistics} />
            <CaseBlock params={nextStageText} />
            <FullWrapper isMargin={false}>
                <div className="avenu__subtitle">Оптимизация конверсий</div>
            </FullWrapper>
            <CaseBlock params={optimizationText} />
            <ScreenshotsCase params={screenShotCase4} />
            <CaseBlock params={paragraph2} className={'avenu__dynamics'} />
            <CaseBlock params={results} />
            <BlocksWithIcons params={statistics2} />
            <DiagrammCase params={diagrammBlock} />
            <TeamCase listTeam={listTeam} />
            <ScrollAnimation animateIn="zoomIn" offset={50} animateOnce={true} duration={1}>
                <FullWrapper>
                    <OfferButton linkText="Нанять команду" />
                </FullWrapper>
            </ScrollAnimation>
            <NextProject NextProject={nextProjectAvenu} />
        </section>
    );
}

export default Avenue;
